import React from 'react';
import PropTypes from 'prop-types';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import FYHMenu from '../../components/menus/FYH';
import ContactModal from '../../components/ContactModal';
import { colors, typography } from '../../styles';

const styles = css`
  .NoRoute_main {
    //background-color: ${colors.color3};
    padding-top: 50px;
    padding-bottom: 80px;;
    @media (min-width: 992px) {
      padding-top: 80px;
      padding-bottom: 110px;
    }
  }
  .NoRoute_pageTitle {
    display: block;
    width: 100%;
    font-family: ${typography.Serif};
    font-weight: 400;
    font-style: italic;
    font-size: 28px;
    color: ${colors.color1};
    letter-spacing: .5px;
    -webkit-background-clip: text;
    text-align:left;
    @media(min-width: 768px) {
      font-size: 30px;
    }
    @media(min-width: 992px) {
      font-size: 30px;
    }
    @media(min-width: 1200px) {
      font-size: 35px;
    }
    &:after {
      content: '';
      display: block;
      width: 75px;
      height: 3px;
      background-color ${colors.color2Light};
      margin: 20px 0 15px 0;
    }
  }

  .NoRoute_bodyCopy {
    p {
      font-size: 16px;
      font-weight: 300;
      line-height: 2.15;
      color: ${colors.color5};
      margin: 0;
      @media (min-width: 768px) {
        font-size: 18px;
      }
      @media (min-width: 992px) {
        font-size: 20px;
        line-height: 2;
      }
      a {
        color: ${colors.color1};
        font-weight: 500;
      }
    }
  }
  .NoRoute_contactButton {
    width: 100%;
    @media(min-width:992px) {
      width: 200px;
    }
  }

`;


function NoRoute({ page }) {
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        title="Page Not Found"
        background={get(page, 'page_image.contentUrl')}
      />
      <FYHMenu />
      <main className="NoRoute_main">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3 className="NoRoute_pageTitle" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'lead_copy'))} />
              <div className="mb-3 pb-3 mb-lg-5">
                <div className="NoRoute_bodyCopy" dangerouslySetInnerHTML={SanitizeHtml(get(page, 'body_copy'))} />
              </div>
              <ContactModal>
                <div className="Btn NoRoute_contactButton">Contact Us</div>
              </ContactModal>
            </div>
          </div>
        </div>
      </main>
    </PageWrapper>
  );
}

NoRoute.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'error_404',
})(NoRoute);



// WEBPACK FOOTER //
// ./src/pages/NoRoute/index.js